import { isNumber, isString } from 'lodash-es';
import numeral from 'numeral';

export function filesize(value: any) {
  if (isNumber(value) || isString(value)) {
    return numeral(value).format('0.0 ib');
  }
  return '';
}

export function preformat(value: any) {
  if (isString(value)) {
    return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  return value;
}
